<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Logout',
  methods: {
    ...mapActions('session', ['logout']),
  },
  async mounted () {
    await this.logout();
    this.$router.replace('/auth');
  },
}
</script>

<style>

</style>